import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { ProcessSection } from '../components/ProcessSection';
import { BriefSection } from '../components/BriefSection';
import { IndustriesSection } from '../components/IndustriesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { CredentialsSection } from '../components/CredentialsSection';
import { CasesSection } from '../components/CasesSection';
import { EngagementSection } from '../components/EngagementSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <ProcessSection />
      <BriefSection />
      <IndustriesSection />
      <BenefitsSection />
      <CredentialsSection />
      <CasesSection />
      <EngagementSection />
      <FAQSection />
      <Footer />
    </>
  );
}
